/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_LSD_EXPORT_ITEM = {
  id: 'lsd_export_sidebar',
  screenId: 'lab-lsd-export',
  label: 'Exportar TXT',
  description: 'Revisar bases F.931 y generar el archivo LSD de liquidación para AFIP.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Revisás por empleado las bases imponibles (rem 1 a 10, rem bruta) y la modalidad de contratación del período, ajustás rem 4 / rem 8 si hace falta para obra social, validás y descargás el TXT de liquidación (registros 01 a 04). Los recibos deben estar cerrados. El TXT de relación de conceptos se descarga en Configuración.',
      },
      {
        title: 'Antes de exportar',
        bullets: [
          'Período habilitado en Laboral → Salarios → Periodos.',
          'Recibos liquidados y cerrados en Liquidación → Recibos.',
          'CUIT de la empresa configurado correctamente.',
          'Empleados con CUIL, obra social, situación de revista y modalidad de contratación.',
          'Conceptos con código LSD y, para el TXT de conceptos, código AFIP + marcas de bases.',
          'Si pagás por acreditación (forma 3), CBU cargado en el legajo.',
        ],
      },
      {
        title: 'Paso 1 — Período y datos del envío',
        fields: [
          { label: 'Período', description: 'Lista de períodos habilitados. Obligatorio.' },
          { label: 'Fecha de pago', description: 'Obligatoria para descargar el TXT.' },
          { label: 'Forma de pago', description: '1 efectivo, 2 cheque, 3 acreditación (pide CBU), 4 externo.' },
          { label: 'Tipo / Nº liquidación', description: 'M mensual, Q quincena, S semanal; número de liquidación del empleador.' },
        ],
      },
      {
        title: 'Paso 2 — Cargar revisión',
        paragraphs: [
          'Tocá «Cargar revisión» para ver la grilla con rem bruta, rem 1, rem 4, rem 8, rem 9 y modalidad efectiva.',
          'Tocá una fila para editar bases y modalidad solo de ese período (no cambia el recibo). Guardá o borrá el override.',
          'Rem 4 = aportes obra social + FSR; rem 8 = contribuciones OS + FSR. Bajalas si un haber no debe entrar en OS.',
        ],
      },
      {
        title: 'Paso 3 — Validar y descargar',
        paragraphs: [
          '«Validar antes de exportar» lista errores (CUIL, códigos LSD, obra social, modalidad, totales).',
          '«Descargar TXT LSD» genera el archivo de liquidación para subir a AFIP / Libro de Sueldos Digital.',
        ],
      },
    ],
  },
}
